// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"_130Ms"};